import React from 'react';
import dayjs from 'dayjs';
import { Image, message, Tooltip } from 'antd';
// import { build } from 'node-xlsx';
import html2canvas from 'html2canvas';
import Icon from '@ant-design/icons';
import * as Icons from '@ant-design/icons';
import number from "async-validator/dist-types/validator/number";

// 导出全部的 icon
export const returnAllIcons = () => {
  const ICON_MAP = Object.keys(Icons).map((key) => {
    if (Icons[key].render && key !== 'default') {
      return {
        name: key,
        component: Icons[key],
      };
    } else {
      return {
        name: '',
        component: '',
      };
    }
  });
  return ICON_MAP;
};

// 整理菜单 icon
export const combineMenuIcon = (menus: any[]) => {
  if (!menus || menus.length === 0) return [];
  const map = (menus: any[]) => {
    const r: any[] = [];
    for (const menu of menus) {
      r.push({
        ...menu,
        icon: menu.icon ? <Icon component={Icons[menu.icon]} /> : menu.icon,
        routes:
          menu.routes && menu.routes.length > 0
            ? menu.routes.map((item: any) => ({
                ...item,
                icon: item.icon ? <Icon component={Icons[item.icon]} /> : item.icon,
              }))
            : menu.routes,
      });
    }
    return r;
  };
  return map(menus);
};

/**
 * 导出文件到 excel
 * @param fileName 文件名称
 * @param data
 * @constructor
 *
 */
export const ExportData = (fileName: string, data: any[]) => {
  // const buffer = build([
  //   {
  //     name: 'mySheet1',
  //     data,
  //   },
  // ]);
  // const aTag = document.createElement('a');
  // const blob = new Blob([buffer]);
  // aTag.download = `${fileName}-${dayjs().format('YYYYMMDDHHmmss')}.xlsx`;
  // aTag.href = URL.createObjectURL(blob);
  // aTag.click();
  // URL.revokeObjectURL(blob as any);
};

// 基础 资源路径
export const baseFileUrl = '';

export const RenderImg = (path: string) => {
  return <Image width={100} src={path} />;
};

// ajax 上传文件
export const uploadFileWithFetch = async (file: File, url: string) => {
  const data = new FormData();
  data.append('file', file);
  const res = await fetch(url, {
    method: 'post',
    body: data,
  });

  return res.json();
};

export function getCaseNameByType(caseType: number): string {
  console.log(caseType);
  switch (parseInt(caseType + '')) {
    case 0:
      return '正常';
    case 1:
      return '火警';
    case 2:
      return '启动';
    case 3:
      return '故障';
    case 4:
      return '屏蔽';
    case 5:
      return '操作';
    case 6:
      return '报警';
    case 7:
      return '气体';
    case 8:
      return '延时';
    case 9:
      return '监管';
    case 10:
      return '反馈';
    case 11:
      return '预警';
    case 12:
      return '电气火灾报警';
    case 13:
      return '可燃气报警';
    case 14:
      return '建筑消防设施报警';
    case 0x20:
      return '消音';
    case 0x21:
      return '复位';
    case 0x22:
      return '校时';
    case 0x40:
      return '上传AD值';
    case 0x41:
      return 'AD命令';
    case 0xa0:
      return '状态查询';
    default:
      return '--';
  }
}

// user token
export const USER_TOKEN = '__user_token__';

// 获取 图片预览的地址
export const generatePreview = (fileName: string): string => {
  return fileName.startsWith('/api/oss-sdk/downloadByFileName?fileName=')
    ? fileName
    : `/api/oss-sdk/downloadByFileName?fileName=${fileName}`;
};

export const px2vh = (px: number, base: number = 1080) => {
  return `${(px / base) * 100}vh`;
};

export const px2vw = (px: number, base = 1920) => {
  return `${(px / base) * 100}vw`;
};

export const $saveOrUpdate = async (req: any) => {
  const { func, params, onSuccess, onError, successInfo = true } = req;

  const hide = message.loading('正在处理');
  try {
    let res = await func(params);
    hide();
    console.log({ res });
    if ((res.hasOwnProperty('code') && res.code !== -1) || (!res.hasOwnProperty('code') && res !== -1)) {
      if (successInfo) {
        message.success('操作成功');
      }
      if (onSuccess) {
        onSuccess(res);
      }
      return true;
    }
    return false;
  } catch (error) {
    hide();
    if (onError) {
      onError(error);
    }
    return false;
  }
};

export const $delete = async (req: any) => {
  const { func, selectedRows, onSuccess, onError } = req;
  const hide = message.loading('正在删除');
  if (!selectedRows) return true;
  try {
    let res = await func({
      idList: selectedRows.map((row: any) => row.id),
    });
    hide();
    message.success('删除成功，即将刷新');
    if (onSuccess) {
      onSuccess(res);
    }
    return true;
  } catch (error) {
    hide();
    message.error('删除失败，请重试');
    if (onError) {
      onError(error);
    }
    return false;
  }
};

// 文字超长展示
export const shortText = (text: string) => {
  return <Tooltip title={text}>{text}</Tooltip>;
};

/**
 * array buffer to base64
 * @param buffer
 */
export const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

// 判断数字类型 如果是数字转为浮点数返回 不是数字返回数字0
export const formatNumber = (n) => {
  // 如果 n 是 number 类型，直接返回（确保不是 NaN）
  if (typeof n === 'number') {
    return isNaN(n) ? 0 : n;
  }

  // 如果 n 是 string 类型，尝试解析
  if (typeof n === 'string') {
    const parsed = parseFloat(n);
    return isNaN(parsed) ? 0 : parsed;
  }
  // 其他情况（如 boolean、object、undefined 等）返回 0
  return 0;
};

// 判断数字类型 如果是数字转为int类型返回 不是数字返回数字0
export const formatNumberInt = (n) => {
  // 如果 n 是 number 类型，直接返回（确保不是 NaN）
  if (typeof n === 'number') {
    return isNaN(n) ? 0 : n;
  }
  // 如果 n 是 string 类型，尝试解析
  if (typeof n === 'string') {
    const parsed = parseInt(n);
    return isNaN(parsed) ? 0 : parsed;
  }
  // 其他情况（如 boolean、object、undefined 等）返回 0
  return 0;
};
// 计算总数
export const  customSumTotalFun = (originData: any, prop1: string) => {
  // 容错处理：非对象/null/undefined直接返回0
  if (!Array.isArray(originData) || !prop1) return 0;
  let resTotal = 0;
  resTotal = originData.reduce((total, row) => {
    let count = formatNumber(row[prop1])
     return total + count;
  }, 0);

  // 判断小数位数并格式化
  const decimalPart = resTotal.toString().split('.')[1];
  if (decimalPart && decimalPart.length > 2) {
    return resTotal.toFixed(2);
  }
  return resTotal
}


// 计算 总价格 单价 *  数量, 返回string类型浮点数字
export const  customPriceTotalFun = (props: {originData: any, priceKey: string, countkey: string} ): string  => {
  // 容错处理：非对象/null/undefined直接返回0
  const {originData, priceKey, countkey} = props || {};
  if (!Array.isArray(originData) || !priceKey || !countkey) return '0';
  let resTotal = 0;
  resTotal = originData.reduce((total, row) => {
     const count = typeof row[countkey] === 'number' ? row[countkey] : 0;
     let price = 0;
     if (typeof row[priceKey] === 'number'){
       price = row[priceKey];
     }
     if (typeof row[priceKey] === 'string'){
       price = parseFloat(row[priceKey]);
     }
     return total + count * price;
  }, 0);
  return resTotal.toFixed(2);
}

// 展示使用这个 随机数 作为唯一id
export const  generateUniqueId = () =>{
  return 'id-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
}

// 判断是否是json字符串
export const isJSONString = (str) => {
  if (typeof str !== 'string') return false;

  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

export const formatOrderInfo = (orderInfo) => {
  let resOrderInfo = [];
  if (isJSONString(orderInfo)) {
    resOrderInfo = JSON.parse(orderInfo) || []
  } else {
    resOrderInfo = orderInfo || []
  }
  return resOrderInfo;
}


export const customFormatTime = (date: string | Date, format = 'YYYY-MM-DD'): string => {
  return dayjs(date).format(format);
};


/**
 * 四舍五入保留两位小数（返回字符串，自动补零）
 * @param {number|string} num 输入数字
 * @returns {string} 保留两位小数的字符串
 */
// 使用示例
// roundToFixedString(5)      // "5"
// roundToFixedString(4.567)  // "4.57"
// roundToFixedString(2.1)    // "2.10"
export const customToFixedString = (num: number | string) => {
  let number = parseFloat(num);
  if (isNaN(number)) {
    number = 0;
  };
  // 处理整数补零情况
  const rounded = (Math.round((number * 100)) / 100).toFixed(2);
  // 移除不必要的零（如 3.00 => 3）
  return rounded.replace(/\.?0+$/, '');
}

/**
 * 四舍五入保留两位小数（返回数字，不补0）
 * @param {number|string} num 输入数字
 * @returns {number} 保留两位小数数字
 */
// 使用示例
// customToFixed2Number(5)      // 5
// customToFixed2Number(4.567)  // 4.57
// customToFixed2Number(2.1034)    // 2.1
export const customToFixed2Number = (num: number | string) => {
  let number = parseFloat(num);
  if (isNaN(number)) {
    number = 0;
  };
  // 处理整数补零情况
  return Math.round(number * 100) / 100;
}

/**
 * 小数转为百分比-
 * @param {number|string}  0.132557123
 * @returns {string} 保留两位小数 -不补0
 * @return 百分比
 * @demol  customFloatToPercentageToFixed2(0.132551)  => 13.26
 */
export const customFloatToPercentageToFixed2 = (num: number | string):number => {
  // 转换为数字类型
  const number = typeof num === 'string' ? parseFloat(num) : num;

  // 处理非数字情况
  if (isNaN(number)) {
    return 0;
  }

  // 乘以100并四舍五入保留两位小数
  const percentage = (number * 100).toFixed(2);

  // 添加百分号
  return parseFloat(percentage);
}


// 从报告看板中迁入---开始
export const customRandomId = () => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  let randomId = '';

  for (let i = 0; i < 16; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomId += characters.charAt(randomIndex);
  }

  return randomId;
};
export const customCopyText = async (text: string) => {
  await navigator.clipboard.writeText(text);
};
export const customCopyUrl = async (text: string) => {
  await customCopyText(window.location.origin + text);
};

export const customFormatUpdateTime = (time: string | null | undefined, type: number = 1) => {
  if (time === null || time === undefined) {
    return '-';
  }
  switch (type) {
    case 1: {
      // '2023-10-21 08:08:07'
      return time?.slice(0, 10) + ' ' + time?.slice(11, 19);
    }
  }
};

export const customDomPic = async (domId: string) => {
  const dom = document.getElementById(domId);
  if (dom === null) {
    console.error('dom获取失败');
    return '';
  }
  const canvas = await html2canvas(dom);
  return canvas.toDataURL();
};


// 从报告看板中迁入---结束
